import { render, staticRenderFns } from "./Clients_Delete.vue?vue&type=template&id=2f8a0502&scoped=true&"
import script from "./Clients_Delete.vue?vue&type=script&lang=js&"
export * from "./Clients_Delete.vue?vue&type=script&lang=js&"
import style0 from "./Clients_Delete.vue?vue&type=style&index=0&id=2f8a0502&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8a0502",
  null
  
)

export default component.exports